import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import {
  APP_ENVS,
  currentAppEnvironment,
} from '@savgroup-front-common/constants';
import { toast } from '@savgroup-front-common/core/atoms/Toast';

import { SellerService } from '@/api';
import { ONBOARDING_PROVISIONING_STATE } from '@/api/Seller/getSalesLeadOnboardingStatusQuery';
import {
  getPreviewApiName,
  getPreviewControlHostname,
} from '@/configuration/getOnboardingHostname';

import messages from '../messages';
import { POLLING_INTERVAL } from '../OnboardingSetUp.constants';

const CONTROL_BASE_BY_ENV: Record<APP_ENVS, string> = {
  DEFAULT: 'dev-app.revers.io',
  DEMO: 'demo-app.revers.io',
  PROD: 'app.revers.io',
  DEV: 'dev-app.revers.io',
  LOCAL: 'localhost:3002',
  TEST: '',
};

const useGetSalesLeadOnboardingStatusQuery = ({
  isEnabled,
}: {
  isEnabled: boolean;
}) => {
  const { requestId, requestToken } = useParams<{
    requestId: string;
    requestToken: string;
  }>();

  const { data, refetch } = useQuery(
    ['getSalesLeadOnboardingStatus', { requestId }],
    async () => {
      const response = await SellerService.getSalesLeadOnboardingStatusQuery({
        id: requestId as string,
      });

      if (response.failure) {
        toast.error(messages.salesLeadConfirmEmailCommandError);

        return undefined;
      }
      if (response.value.demoContextFullyProvisionned) {
        const controlBase =
          getPreviewControlHostname() ??
          CONTROL_BASE_BY_ENV[currentAppEnvironment];

        const invitationParams = new URLSearchParams([
          ['invitation_id', response.value.invitationId],
          ['invitation_token', requestToken ?? ''],
        ]);
        const previewApiName = getPreviewApiName();

        if (previewApiName) {
          invitationParams.set('api', previewApiName);
        }

        window.location.href = `https://${controlBase}/invitation?${invitationParams}`;
      }

      return response.value;
    },
    {
      enabled: isEnabled && !!requestId,
      refetchInterval: (status) =>
        status?.provisioningState === ONBOARDING_PROVISIONING_STATE.FAILED
          ? false
          : POLLING_INTERVAL,
    },
  );

  return { status: data, refetch };
};

export default useGetSalesLeadOnboardingStatusQuery;
